import React, { useEffect, useState } from "react";
import { Form, message } from "antd";
import { SaveButton, InputText, CancelButton, ModalComponent, trans, SelectWithSearch } from "@comps/components"
import { makeRequest, makeRequestStateless, getErrorProps } from "@utils/helpers";
import { createDataReq, getAllcountriesReq } from "../requests";
import { Commons, Const } from "../../../constants";
import { createSelectList } from '@comps/commonFunctions';
const langKey = Const["city"].lngKey
const formName = "createCity";

const CreateCity = (props) => {
  const [loader, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const [countries, setCountries] = useState([]);
  useEffect(() => {
    makeRequestStateless(getAllcountriesReq, false, onGetCountries, false)
    // eslint-disable-next-line
  }, []);
  const onGetCountries = (response) => {
    setCountries(createSelectList(response.countries))
  }

  const onSubmit = (data) => {
    setSaveLoader(true)
    const payload = { city: data };
    makeRequest(setLoader, createDataReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {
    setSaveLoader(false)
    message.success("City Saved successfully");
    props.onCompleted(data.citys.data);
    props.onSuccess(data)
  }

  const onError = (err, res) => {
    setSaveLoader(false)
    message.error(res.response.data.message);
  }

  //-----------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------

  const footer = [
    <SaveButton loading={ saveLoader } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent top={ 20 } width={ 600 } maskClosable={ false }
      mainTitle={ trans(Commons.create) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      <Form { ...formLayout } name={ formName } onFinish={ onSubmit } scrollToFirstError>
        <Form.Item name="name" rules={ rules.name } label={ trans(`${langKey}.name`) }
          className="da-mb-16"
          { ...getErrorProps(errors['name']) } size="small"
        >
          <InputText placeholder={ trans(`${langKey}.name`) } />
        </Form.Item>

        <Form.Item name="state_id" label={ trans(`${langKey}.state`) } rules={ rules.state_id } className="da-mb-16"
          { ...getErrorProps(errors['state_id']) }
        >
          <SelectWithSearch
            placeholder={ trans(`${langKey}.state`) }
            options={ createSelectList(props.states) }
          />
        </Form.Item>

      </Form>
    </ModalComponent>
  )
}

export default CreateCity

const rules = {
  name: [
    { required: true, message: trans(`${langKey}.name.req`) },
  ],
  state_id: [
    { required: true, message: trans(`${langKey}.state.req`) },
  ],

};

const formLayout = {
  // layout: "horizontal",
  labelCol: { span: 6 },
  wrapperCol: { span: 14, offset: 2 },
  labelAlign: "left"
}